module.exports = __webpack_public_path__ + "static/carrion_crawler-12c4612a552d60f6886e99b2dd6fb345.jpeg";